import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfigService } from 'src/app/core/app-config.service';
import { Message } from '../models/message';
import { TypedDataService } from 'src/app/core/typed-data.service';
import { QueueMessage } from '../models/queue-message';
import { TopicMessage } from '../models/topic-message';
import { SubscriptionMessage } from '../models/subscription-message';

@Injectable({
  providedIn: "root",
})
export class QueueMessageDataService extends TypedDataService<string, Message> {
  constructor(http: HttpClient, acs: AppConfigService) {
    super(http, "QueueMessages", acs, false);
  } 

  addMessage(message: QueueMessage){
    return this.http.post<QueueMessage>(
      `${this.baseUrl}odata/${this.resourceName}/`,
      message
    );    
  }
}

@Injectable({
  providedIn: "root",
})
export class QueueDeadLetterMessageDataService extends TypedDataService<string, Message> {
  constructor(http: HttpClient, acs: AppConfigService) {
    super(http, "QueueDeadLetterMessages", acs, false);
  } 

  deleteMessage(message: QueueMessage) {
    const url = `${this.baseUrl}odata/${this.resourceName}/${message.Id}?connectionId=${message.ConnectionId}&queueName=${message.Queue}`;
    return this.http.delete(url);
  }
}

@Injectable({
  providedIn: "root",
})
export class TopicMessageDataService extends TypedDataService<string, Message> {
  constructor(http: HttpClient, acs: AppConfigService) {
    super(http, "TopicMessages", acs, false);
  } 

  addMessage(message: TopicMessage){
    return this.http.post<TopicMessage>(
      `${this.baseUrl}odata/${this.resourceName}/`,
      message
    );    
  }
}

@Injectable({
  providedIn: "root",
})
export class SubscriptionMessageDataService extends TypedDataService<string, Message> {
  constructor(http: HttpClient, acs: AppConfigService) {
    super(http, "SubscriptionMessages", acs, false);
  } 
}

@Injectable({
  providedIn: "root",
})
export class SubscriptionDeadLetterMessageDataService extends TypedDataService<string, Message> {
  constructor(http: HttpClient, acs: AppConfigService) {
    super(http, "SubscriptionDeadLetterMessages", acs, false);
  } 

  deleteMessage(message: SubscriptionMessage) {
    const url = `${this.baseUrl}odata/${this.resourceName}/${message.Id}?connectionId=${message.ConnectionId}&topic=${message.Topic}&subscription=${message.Subscription}`;
    return this.http.delete(url);
  }
}